/**
 * Every route becomes a chunk, loaded only when used.
 * Reduces size of initial App load.
 */
export default [
  {
    path: '*',
    redirect: {
      path: '/404'
    }
  }, {
    name: 'default',
    path: '/',
    title: 'NannyGranny',
    component: require('@/views/app/home/index.vue').default,
    meta: {title: "Find Reliable Nanny Services to Support Your Family's Needs"}
  }, {
    name: 'login',
    path: '/login',
    component: require('@/views/app/auth/login/index.vue').default,
    meta: {title: 'Login - NannyGranny'}
  }, {
    name: 'unsubscribe',
    path: '/unsubscribe',
    component: require('@/views/app/unsubscribe/index.vue').default,
    meta: {title: 'Unsubscribe - NannyGranny'}
  }, {
    path: '/oauth2/:type/:role',
    name: 'oauth2-type',
    component: require('@/views/app/auth/components/auth-social.vue').default
  }, {
    name: 'register',
    path: '/register',
    component: require('@/views/app/auth/register/index.vue').default,
    meta: {title: 'Register - NannyGranny'}
  }, {
    path: '/signup',
    component: require('@/views/app/auth/signup/index.vue').default,
    meta: {auth: false, title: 'Signup - NannyGranny'},
    children: [
      {
        path: '',
        component: require('@/views/app/auth/signup/components/auth-signup-step-1.vue').default
      }, {
        path: ':step(step-2)/:role(parent)',
        component: require('@/views/app/auth/signup/components/auth-signup-step-2-parent.vue').default,
        props: true
      }, {
        path: ':step(step-3)/:role(parent)-free',
        component: require('@/views/app/auth/signup/components/auth-signup-step-3-parentalternate.vue').default,
        props: true
      }, {
        path: ':step(step-2)/:role(nanny)',
        component: require('@/views/app/auth/signup/components/auth-signup-step-2-nanny.vue').default,
        props: true
      }, {
        path: ':step(step-3)/:role(parent)',
        component: require('@/views/app/auth/signup/components/auth-signup-step-3-parent.vue').default,
        props: true
      }, {
        path: ':step(step-3)/:role(nanny)',
        component: require('@/views/app/auth/signup/components/auth-signup-step-3-nanny.vue').default,
        props: true
      }, {
        path: ':step(step-3)/:role(nanny)/fill-profile',
        component: require('@/views/app/profile/index').default,
        props: {isFromSignup: true}
      }
    ]
  }, {
    name: 'logout',
    path: '/logout',
    component: require('@/views/app/auth/components/auth-logout.vue').default
  }, {
    name: 'forgot-password',
    path: '/forgot-password',
    component: require('@/views/app/auth/password/reset-password.vue').default,
    meta: { title: 'Forgot password - NannyGranny' }
  }, {
    name: 'reset-password',
    path: '/reset-password/:token',
    component: require('@/views/app/auth/password/enter-new-password.vue').default,
    meta: { title: 'Reset password - NannyGranny' },
    props: true
  }, {
    name: 'account',
    path: '/account',
    component: require('@/views/app/account/index').default,
    meta: { auth: true, title: 'My Account - NannyGranny' }
  }, {
    name: 'profile',
    path: '/profile',
    component: require('@/views/app/profile/index').default,
    meta: { auth: ['nanny'], title: 'My Profile - NannyGranny' },
    props: { isFromSignup: false }
  }, {
    name: 'dashboard',
    path: '/dashboard',
    component: require('@/views/app/dashboard/index').default,
    meta: { auth: true, title: 'Dashboard - NannyGranny' }
  }, {
    name: 'subscription',
    path: '/subscription',
    component: require('@/views/app/subscription/index.vue').default,
    meta: { auth: ['parent'], title: 'My Membership - NannyGranny' }
  },
  // NANNIES
  // ====================
  {
    path: '/nannies',
    component: require('@/views/app/nannies/nannies.vue').default,
    meta: {
      title: 'Expert Nanny Services – Our Trusted Childcare For Every Family',
      canonical: 'https://nannygranny.com.au/nannies',
      postcode: null
    }
  }, {
    path: '/nanny-show/:nannyId',
    component: require('@/views/app/nannies/nanny-detail.vue').default,
    meta: { title: 'NannyGranny profile - NannyGranny', transitionName: 'scale-transition' },
    props: true
  },

  // PARENTS
  // ====================
  {
    path: '/parent-show/:parentId',
    component: require('@/views/app/parents/parent-detail.vue').default,
    meta: { title: 'Parent profile - NannyGranny', transitionName: 'scale-transition' },
    props: true
  },

  // JOBS
  // =====================
  {
    path: '/jobs',
    component: require('@/views/app/jobs/jobs.vue').default,
    meta: {
      title: 'Find The Best Nanny Jobs – Rewarding Roles With Great Pay',
      canonical: 'https://nannygranny.com.au/jobs',
      postcodeId: null
    }
  }, {
    path: '/job-show/:jobId',
    component: require('@/views/app/jobs/job-detail.vue').default,
    meta: { title: 'Job - NannyGranny', transitionName: 'scale-transition' },
    props: true
  }, {
    name: 'job-post',
    path: '/job-post',
    component: require('@/views/app/jobs/job-post.vue').default,
    meta: { auth: ['parent'], title: 'Post job - NannyGranny' },
    props: { isListing: false }
  }, {
    name: 'job-listing',
    path: '/job-listing',
    component: require('@/views/app/jobs/job-update.vue').default,
    props: { isListing: true },
    meta: { auth: ['parent'], title: 'Job listing - NannyGranny' }
  },
  {
    path: '/new-job-post',
    component: require('@/views/app/newjobs/jobs.vue').default,
    meta: { title: 'Find The Best Nanny Jobs – Rewarding Roles With Great Pay', postcodeId: null }
  },
  // INBOX
  // ====================
  {
    name: 'inbox',
    path: '/inbox',
    component: require('@/views/app/inbox/index.vue').default,
    meta: { auth: true, title: 'Inbox - NannyGranny' }
  },
  // CHAT
  // ====================
  {
    path: '/chat/:roomId(\\d+)',
    component: require('@/views/app/chat/index.vue').default,
    meta: { auth: true, title: 'Chat - NannyGranny' },
    props: true
  }, {
    path: '/chat/message-create',
    component: require('@/views/app/chat/chat-message-create.vue').default,
    meta: { auth: ['nanny'], title: 'Create a message - NannyGranny' }
  },
  // FAVOURITES
  // ====================
  {
    name: 'favourites',
    path: '/favourites',
    component: require('@/views/app/favourites/index.vue').default,
    meta: { auth: true, title: 'My favourites - NannyGranny' }
  },
  // CONNECTIONS
  // ====================
  {
    name: 'connections',
    path: '/connections',
    component: require('@/views/app/connections/index.vue').default,
    meta: { auth: true, title: 'My connections - NannyGranny' }
  },
  // REVIEWS
  // ====================
  {
    name: 'reviews',
    path: '/reviews',
    component: require('@/views/app/reviews/index.vue').default,
    meta: { auth: true, title: 'My Reviews - NannyGranny' }
  },
  // OTHER
  // ====================
  // {
  //   name: 'search',
  //   path: '/search-nanny',
  //   title: 'Find NannyGranny',
  //   component: require('@/views/app/search/search-nanny.vue').default
  // },
  // CLUBHOUSE
  // ====================
  // Legacy /clubhouse links (CMS content, emails) now live under /blog
  {
    path: '/clubhouse',
    redirect: '/blog'
  }, {
    path: '/clubhouse/*',
    redirect: to => to.path.replace(/^\/clubhouse/, '/blog')
  },
  {
    path: '/blog',
    component: require('@/views/app/clubhouse/index.vue').default,
    meta: {
      title: 'Blog – A Supportive Community for Nannies & Families || NannyGranny',
      description: 'Join the NannyGranny Clubhouse: Articles, forums, and a caring community for nannies and families.',
      keywords: 'nanny blogs, nanny community, parenting support, nanny forum, childcare advice',
      canonical: 'https://nannygranny.com.au/blog'
    },
    children: [
      {
        name: 'blog',
        path: '/',
        component: require('@/views/app/clubhouse/public/index2.vue').default,
        // component: require('@/views/app/clubhouse/public/index.vue').default,
        meta: {
          title: 'Clubhouse Home – NannyGranny',
          description: 'Explore blog posts, updates, and stories from the NannyGranny community.',
          keywords: 'nanny tips, parenting blogs, caregiver stories, nanny articles',
        }
      }, {
        path: '/blog/nanny',
        component: require('@/views/app/clubhouse/nanny/clubhouse-nanny.vue').default,
        meta: {
          auth: ['nanny'],
          title: 'Nanny Clubhouse – NannyGranny',
          description: 'Private area for nannies to share and grow within the NannyGranny network.',
          keywords: 'nanny forum, private nanny community, nanny advice, support group',
        }
      }, {
        path: '/blog/category/:categoryname',
        component: require('@/views/app/clubhouse/public/clubhouse-category.vue').default,
        meta: {
          title: 'Clubhouse Category – NannyGranny',
          description: 'Browse content by categories in the Clubhouse.',
          keywords: 'nanny categories, childcare topics, blog filters, parenting help',
        },
        props: true
      },
      //  {
      //   path: '/blog/:slug',
      //   component: require('@/views/app/clubhouse/article/clubhouse-article.vue').default,
      //   // meta: {
      //   //   title: 'Read Article – NannyGranny Clubhouse',
      //   //   description: 'Insightful reads from experienced caregivers, parents, and industry experts.',
      //   //   keywords: 'nanny articles, parenting blog, caregiving stories, expert advice',
      //   // },
      //   props: true
      // },
      {
        path: '/blog/:slug',
        component: () => ({
          component: import('@/views/app/clubhouse/article/clubhouse-article.vue'),
          loading: require('@/components/app-loader.vue').default,
          error: require('@/views/errors/error.vue').default,
          delay: 200,
          timeout: 10000
        }),
        props: true
      },
      {
        path: '/blog/forum',
        component: require('@/views/app/clubhouse/forum/clubhouse-forum.vue').default,
        meta: {
          auth: ['nanny'],
          title: 'Nanny Forum – Clubhouse | NannyGranny',
          description: 'Ask questions, give advice, and join engaging conversations with other nannies.',
          keywords: 'nanny forum, community chat, caregiving Q&A, nanny support',
        }
      }, {
        path: '/blog/club/category/:categoryId(\\d+)',
        component: require('@/views/app/clubhouse/clubs/index.vue').default,
        meta: {
          auth: ['nanny'],
          title: 'Club Categories – NannyGranny Clubhouse',
          description: 'Explore exclusive clubs based on your interests and expertise.',
          keywords: 'nanny clubs, caregiving groups, nanny interests, exclusive clubs',
        },
        props: true
      }, {
        path: '/blog/club/:clubId(\\d+)',
        component: require('@/views/app/clubhouse/clubs/clubhouse-club-show.vue').default,
        meta: {
          auth: ['nanny'],
          title: 'Club Details – NannyGranny Clubhouse',
          description: 'Learn more about the selected club, its members, and upcoming discussions.',
          keywords: 'nanny club details, private group info, nanny events, club members',
        },
        props: true
      }
    ]
  },
  // CONTENT PAGES
  // ====================
  {
    name: 'contact-us',
    path: '/contact-us',
    component: require('@/views/content/contact-us/index.vue').default,
    meta: { title: 'Get in Touch with NannyGranny - Expert Care Solutions Across Australia' }
  }, {
    name: 'about-us',
    path: '/about-us',
    component: require('@/views/content/about-us/index.vue').default,
    meta: { title: 'Trusted Nanny Services – About NannyGranny Childcare and Nanny Agency' }
  }, {
    name: 'faqs',
    path: '/faqs',
    component: require('@/views/content/faqs/index.vue').default,
    meta: { title: 'NannyGranny FAQs – Everything You Need To Know About Our Services' }
  },

  {

    name: 'recommended-nanny',
    path: '/recommended-nanny',
    component: require('@/views/app/recommendednanny/index.vue').default,
    meta: {title: 'Nannygranny recommended'}
  },
/*
  // {
    // name: 'safety',
    // path: '/safety',
    // component: require('@/views/content/safety/index.vue').default,
    // meta: {title: 'Online Safety - NannyGranny'}
  // },
*/
  {
    name: 'testimonials',
    path: '/testimonials',
    component: require('@/views/content/testimonials/index.vue').default,
    meta: { title: 'NannyGranny Childcare Agency – Trusted Reviews & Happy Families' }
  }, {
    name: 'how-it-works',
    path: '/how-it-works/find-your-nanny',
    component: require('@/views/content/how-it-works/index.vue').default,
    meta: { title: 'Discover Reliable Nannies – Get the Best Care for Your Child' }
  },
  {
    name: 'how-it-works-new',
    path: '/how-it-works',
    component: require('@/views/content/how-it-works-new/index.vue').default,
    meta: {
      title: 'Discover Reliable Nannies – Get the Best Care for Your Child',
      canonical: 'https://nannygranny.com.au/how-it-works'
    }
  }, {
    name: 'how-it-works-nanny',
    path: '/how-it-works/become-a-nanny',
    component: require('@/views/content/how-it-works/index-nanny.vue').default,
    meta: { title: 'Become a NannyGranny – Start Your Childcare Journey Today' }
  }, {
    name: 'legal',
    path: '/legal',
    component: require('@/views/content/legal/index.vue').default,
    meta: { title: 'Your Peace of Mind Matters – NannyGranny Legal Info & Policies' }
  }, {
    name: 'privacy-policy',
    path: '/privacy-policy',
    component: require('@/views/content/privacy-policy/index.vue').default,
    meta: {
      title: 'Privacy Policy - NannyGranny',
      canonical: 'https://nannygranny.com.au/privacy-policy'
    }
  }, {
    name: 'participation-agreement',
    path: '/participation-agreement',
    component: require('@/views/content/participation-agreement/index.vue').default,
    meta: { title: 'NannyGranny Agreement – Secure & Professional Childcare Terms' }
  }, {
    name: 'child-care-rebate',
    path: '/child-care-rebate',
    component: require('@/views/content/child-care-rebate/index.vue').default,
    meta: {
      title: 'Make Childcare Affordable – NannyGranny Child Care Rebate Guide',
      canonical: 'https://nannygranny.com.au/child-care-rebate'
    }
  }, {
    path: '/404',
    name: 'not-found',
    component: require('@/views/errors/not-found.vue').default,
    meta: { title: '404 - NannyGranny' }
  }, {
    path: '/403',
    name: 'access-denied',
    component: require('@/views/errors/access-denied.vue').default,
    meta: { title: '403 - NannyGranny' }
  }, {
    path: '/500',
    name: 'server-error',
    component: require('@/views/errors/error.vue').default,
    meta: { title: '500 - NannyGranny' }
  }
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
// function lazyLoadView (AsyncView) {
//   const AsyncHandler = () => ({
//     component: AsyncView,
//     // A component to use while the component is loading.
//     loading: require('@/components/app-loading.vue').default,
//     // A fallback component in case the timeout is exceeded
//     // when loading the component.
//     error: require('@/views/errors/error.vue').default,
//     // Delay before showing the loading component.
//     // Default: 200 (milliseconds).
//     delay: 500,
//     // Time before giving up trying to load the component.
//     // Default: Infinity (milliseconds).
//     timeout: 10000
//   })
//
//   return Promise.resolve({
//     functional: true,
//     render (h, { data, children }) {
//       // Transparently pass any props or children
//       // to the view component.
//       return h(AsyncHandler, data, children)
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/http/routes.js